import { TourConfig } from '../services/tour-guide.service';

export const SHIPMENT_REQUEST_TOUR_CONFIG: TourConfig = {
  id: 'shipment-request-tour',
  name: 'Guida alla Richiesta Spedizione',
  steps: [
    {
      id: 'welcome',
      selector: '.main-title',
      title: '👋 Benvenuto nella Richiesta Spedizione',
      content: 'Questa guida ti mostrerà come utilizzare tutte le funzionalità per creare e gestire le tue spedizioni. Clicca "Avanti" per iniziare il tour.',
      position: 'bottom',
      showNext: true,
      showPrev: false,
      showSkip: true
    },
    {
      id: 'form-toggle',
      selector: 'button[aria-controls="shipmentForm"]',
      title: '📝 Controllo Form',
      content: 'Usa questo pulsante per aprire o chiudere il form di inserimento. Il form è collassabile per risparmiare spazio quando non serve.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true,
      beforeShow: () => {
        // Assicurati che il form sia chiuso per mostrare il pulsante
        const component = (window as any).shipmentComponent;
        if (component && !component.isFormCollapsed) {
          component.toggleFormCollapse();
        }
      }
    },
    {
      id: 'client-selection',
      selector: '#waybillClientCode',
      title: '👤 Selezione Cliente',
      content: 'Inizia sempre selezionando il cliente. <strong>Questo è fondamentale</strong> perché determinerà quali brand e dealer saranno disponibili per la spedizione.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true,
      beforeShow: () => {
        // Apri il form se è chiuso
        const component = (window as any).shipmentComponent;
        if (component && component.isFormCollapsed) {
          component.toggleFormCollapse();
        }
      }
    },
    {
      id: 'brand-selection',
      selector: '#waybillBrandCode',
      title: '🏷️ Selezione Brand',
      content: 'Dopo aver selezionato il cliente, scegli il brand. I brand disponibili dipendono dal cliente selezionato.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'date-selection',
      selector: '#waybillDate',
      title: '📅 Data Richiesta',
      content: 'Seleziona la data per la spedizione. <strong>Attenzione:</strong> le richieste dopo le 17:00 saranno processate il giorno lavorativo successivo.',
      position: 'top',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'parcels-section',
      selector: '.card.form-section:nth-of-type(2) .header-title',
      title: '📦 Gestione Colli',
      content: 'In questa sezione gestisci tutti i colli della spedizione. Ogni collo ha peso, dimensioni e valore assicurato.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'distributive-insert-button',
      selector: '.card.form-section:nth-of-type(2) .card-header button.btn-primary',
      title: '🎯 Inserimento Distributivo',
      content: 'Funzione avanzata per creare automaticamente più colli distribuendo peso e volume totale in modo equo. <strong>Ideale per spedizioni uniformi</strong> - sostituisce tutti i colli esistenti con quelli nuovi distribuiti.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'parcel-weight',
      selector: '#parcelWeight0',
      title: '⚖️ Peso del Collo',
      content: 'Inserisci il peso in kg. <strong>Campo obbligatorio</strong> - minimo 0.001 kg, massimo 99999.999 kg.',
      position: 'top',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'parcel-volume',
      selector: '#parcelVolume0',
      title: '📐 Volume del Collo',
      content: 'Inserisci il volume in m³. <strong>Campo obbligatorio</strong> - minimo 0.0001 m³, massimo 99999.9999 m³.',
      position: 'top',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'parcel-insured-value',
      selector: '#parcelInsuredValue0',
      title: '💰 Valore Assicurato',
      content: 'Inserisci il valore assicurato del collo. Se richiesto dalla spedizione. Serve per la copertura assicurativa in caso di smarrimento o danno.',
      position: 'top',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'parcel-collapsed-info',
      selector: '.parcel-summary-inline',
      title: '📋 Parametri Collo Chiuso',
      content: 'Quando un collo è chiuso, vedi una sintesi dei parametri principali sulla stessa riga del titolo: <strong>Descrizione</strong> (in blu), <strong>Peso</strong> (kg), <strong>Volume</strong> (m³), <strong>Valore Assicurato</strong> (€) e <strong>Dimensioni</strong> (LxLxA cm). I valori vuoti vengono mostrati con "-".',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true,
      beforeShow: () => {
        // Assicurati che ci sia almeno un collo e che sia chiuso
        const component = (window as any).shipmentComponent;
        if (component && component.parcelsArray && component.parcelsArray.length > 0) {
          // Chiudi il primo collo per mostrare i parametri inline
          component.parcelsCollapsed[0] = true;
        }
      }
    },
    {
      id: 'parcel-focus-button',
      selector: 'button:has(.fa-eye)',
      title: '👁️ Pulsante Focus Singolo',
      content: 'Il pulsante con l\'<strong>occhio</strong> (blu) ti permette di aprire solo questo collo e chiudere automaticamente tutti gli altri. Utile per concentrarsi su un collo specifico.',
      position: 'left',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'parcel-toggle-button',
      selector: 'button:has(.fa-chevron-up, .fa-chevron-down)',
      title: '🔽 Pulsante Apertura/Chiusura Individuale',
      content: 'Il pulsante con la <strong>freccia</strong> (grigio) apre o chiude solo questo singolo collo senza influenzare gli altri. La freccia su indica collo aperto, freccia giù indica collo chiuso.',
      position: 'left',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'reset-parcels-button',
      selector: 'button[class*="btn-outline-secondary"]:has(i.fa-undo)',
      title: '🔄 Reset Colli',
      content: 'Elimina tutti i colli esistenti e ricomincia con un singolo collo vuoto. <strong>Attenzione:</strong> questa azione richiede conferma e non può essere annullata.',
      position: 'left',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'add-parcel-button',
      selector: 'button[class*="btn-primary"]:has(i.fa-plus)',
      title: '➕ Aggiungi Colli',
      content: 'Usa questo pulsante per aggiungere più colli alla spedizione. Puoi aggiungere fino a un massimo prestabilito. <strong>Nota:</strong> quando aggiungi un nuovo collo, tutti gli altri si chiudono automaticamente.',
      position: 'left',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'parcels-summary',
      selector: '.d-flex.gap-4',
      title: '📊 Riassunto Colli',
      content: 'Qui vedi il riassunto in tempo reale della spedizione: numero totale colli, peso, volume e valore assicurato.',
      position: 'top',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'destination-section',
      selector: '.card.form-section:nth-of-type(3) .header-title',
      title: '🎯 Dati Destinazione',
      content: 'Qui inserisci tutti i dati del destinatario della spedizione: dealer, indirizzo, contatti.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'dealer-code',
      selector: '#dealerCode',
      title: '🏢 Codice Dealer',
      content: 'Inserisci il codice del dealer. <strong>Suggerimento:</strong> inizia a digitare e vedrai i suggerimenti automatici basati su cliente e brand selezionati.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'dealer-autocomplete',
      selector: '#dealerName',
      title: '🔍 Autocompletamento',
      content: 'Tutti i campi dealer supportano autocompletamento. Puoi cercare per codice, nome o P.IVA e il sistema compilerà automaticamente gli altri campi.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'summary-section',
      selector: '.card.mt-4:has(.fa-chart-pie)',
      title: '📈 Riepilogo',
      content: 'Il riepilogo mostra statistiche in tempo reale di tutte le spedizioni inserite: bolle totali, colli, peso, volume e valore.',
      position: 'top',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'data-table',
      selector: '.card.mt-4:last-of-type .header-title',
      title: '📋 Gestione Dati',
      content: 'In questa sezione visualizzi e gestisci tutte le spedizioni inserite. Puoi passare dalla vista bolle alla vista colli.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'view-toggle',
      selector: '.btn-group:has(.fa-file-alt)',
      title: '👁️ Modalità Visualizzazione',
      content: 'Cambia tra vista "Bolle" e vista "Colli" per vedere i dati da prospettive diverse.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'display-mode',
      selector: '.btn-group:has(.fa-table)',
      title: '🗂️ Formato Display',
      content: 'Scegli tra visualizzazione a tabella (più compatta) o a schede (più dettagliata).',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'search-box',
      selector: '.search-container',
      title: '🔍 Ricerca',
      content: 'Usa la ricerca per trovare rapidamente spedizioni specifiche. Cerca per codice bolla, destinatario, città, ecc.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'export-excel',
      selector: 'button:has(.fa-file-excel)',
      title: '📊 Export Excel',
      content: 'Esporta tutti i dati in formato Excel per analisi o archiviazione.',
      position: 'bottom',
      showNext: true,
      showPrev: true,
      showSkip: true
    },
    {
      id: 'tour-complete',
      selector: '.main-title',
      title: '🎉 Tour Completato!',
      content: 'Ora conosci tutte le funzionalità principali. <strong>Suggerimento:</strong> puoi riavviare questa guida in qualsiasi momento dal menu aiuto.',
      position: 'bottom',
      showNext: false,
      showPrev: true,
      showSkip: false
    }
  ]
};
